import React from 'react';

import { useQuery } from 'react-query';
import { fetchOrderDetail } from 'api/order';
import { useParams, useNavigate } from 'react-router-dom';

import { SiteOrderProps } from './SiteOrder.props';

import SiteOrderView from './SiteOrder.view';

const SiteOrderContainer = (props: SiteOrderProps) => {
  const params = useParams();
  const portalId = params.portalId || '';
  const orderId = params.orderId || '';
  const navigate = useNavigate();

  const queryKey = ['fetch-site-order', portalId, orderId];
  const queryFn = () => fetchOrderDetail(portalId, orderId);
  const options = {
    enabled: !!portalId && !!orderId,
  };

  const { data, isLoading } = useQuery(queryKey, queryFn, options);

  return (
    <SiteOrderView
      order={data}
      isLoading={isLoading}
      goBack={() => navigate(-1)}
    />
  );
};

export default SiteOrderContainer;
